import React from 'react';

interface ProgressProps {
  value: number;
  max: number;
  label?: string;
  showValue?: boolean;
  className?: string;
}

export const Progress: React.FC<ProgressProps> = ({
  value,
  max,
  label,
  showValue = true,
  className = '',
}) => {
  const percentage = Math.min(Math.round((value / max) * 100), 100);

  return (
    <div className={`space-y-2 ${className}`}>
      {(label || showValue) && (
        <div className="flex justify-between text-sm">
          {label && <span style={{ color: 'var(--color-text)', opacity: 0.8 }}>{label}</span>}
          {showValue && (
            <span style={{ color: 'var(--color-text)', opacity: 0.8 }}>
              {percentage}%
            </span>
          )}
        </div>
      )}
      <div 
        className="h-2 rounded-full overflow-hidden"
        style={{ backgroundColor: 'var(--color-card-bg)' }}
      >
        <div
          className="h-full transition-all duration-300 ease-out"
          style={{ 
            width: `${percentage}%`,
            background: 'linear-gradient(to right, var(--color-primary), var(--color-secondary))'
          }}
        />
      </div>
    </div>
  );
};
